import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Program Track Products Config"})
export default class Config {

	@Input({type: InputType.CHECKBOX, title: "Show Progress Bars"})
	public showProgress: boolean = true;

}



// WEBPACK FOOTER //
// ./src/panels/programTrackProducts/Config.ts